import { FC } from 'react';
import {
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';

/**
 * Stands in for the drawer body while `orderDetails` is in flight.
 *
 * The drawer opens immediately rather than waiting on the fetch, so this is
 * what the customer sees for the duration of one request on an explicit action.
 *
 * The blocks are decorative and carry no text to read, so the wait is
 * announced by the wrapper instead: `role="status"` makes it a polite live
 * region, `aria-busy` marks the region as still filling, and the `aria-label`
 * is the announcement itself. Without them the panel reads as empty rather
 * than as pending. Arrival is announced by the content that replaces this, the
 * same way the error path leans on `Alert`'s own alert role. Only `Skeleton`
 * forwards unknown props to its element; `SkeletonContent` does not, so the
 * attributes go on the outer wrapper.
 */
export const FulfillmentDetailsSkeleton: FC = () => (
  <Skeleton
    disablePadding
    grow
    data-testid="fulfillment-details-skeleton"
    role="status"
    aria-busy="true"
    aria-label="Loading order details"
  >
    <SkeletonContent orientation="vertical" disablePadding>
      <SkeletonBlock aspect="wide" height={6} />
      <SkeletonLine variant="multi" />
      <SkeletonBlock aspect="wide" height={8} />
    </SkeletonContent>
  </Skeleton>
);
